const o=(o,t)=>o===t?0:o+1===t?"-100%":o-1===t?"100%":o<t?"-200%":"200%";export{o as getLeft};
//# sourceMappingURL=videoListUtils.js.map
